import { Component, Event, EventEmitter, h, Prop } from "@stencil/core";
import CookieService from "@globals/helpers/cookie.service";
import config from "../../environment/environment-config";

@Component({
  tag: "bcp-login-button",
})
export class BcpLoginButton {
  @Prop() buttonLabel = "Login";
  @Prop() loginUrl: string;
  @Prop() profileFlyoutId = "f-profile-flyout";

  @Event() skidLoginButtonClicked: EventEmitter;

  private enableOverlay = config.singleKeyIdConfig.enableOverlay;
  private cookieName = config.singleKeyIdConfig.cookieName;

  private handleButtonClick = (): void => {
    if (
      !this.enableOverlay ||
      !document.querySelector("bcp-skid-overlay") ||
      CookieService.getCookie(this.cookieName) != null
    ) {
      location.replace(this.loginUrl);
      return;
    }

    (
      document.getElementById(this.profileFlyoutId) as HTMLFFlyoutElement
    )?.closeFlyout(false);
    this.skidLoginButtonClicked.emit();
  };

  render() {
    return (
      <f-button onClick={this.handleButtonClick} fullWidth={true}>
        {this.buttonLabel}
      </f-button>
    );
  }
}
